import React from 'react'
import {SetBannerTitle} from '../../layouts/components/BannerTitle'

const Page = () => (
  <React.Fragment>
   <SetBannerTitle value="Careers" />
   <div className="services-content">
      <section className="divided-section-content">
        <h3>Career Form here</h3>
      </section>
    </div>


  </React.Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/about/careers.js